module.exports = __webpack_public_path__ + "media/images/sports_icons/014-kettlebell-f3f258bf3c22175454c9671df2e16e29.png";